module.exports = __webpack_public_path__ + "static/media/katusiime_ndera4.0cfc35c3.jpg";